/* A generic mapping function, reuable for all CS responses */

const mapCsConnectionToArray = csConnection => csConnection.edges && csConnection.edges.map(edge => edge.node);

export default mapCsConnectionToArray;
